var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"rk-comparison flex-h"},[_c('ConparisonCharts',{attrs:{"chartSource":_vm.comparison.chartSource}}),_c('ConparisonConfig',{attrs:{"currentOptions":_vm.comparison.currentOptions,"optSource":_vm.comparison.dataSource}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }